/** Text inserted when a user is picked from the mention dropdown. */
export function mentionInsertText(user) {
  const username = String(user?.username || "").trim();
  if (username) return `@${username}`;
  const email = String(user?.email || "").trim();
  const local = email.split("@")[0];
  return local ? `@${local}` : "@";
}

/** Label shown for a stored mention (API object or legacy email string). */
export function mentionDisplayLabel(mention) {
  if (mention && typeof mention === "object") {
    return (
      mention.username ||
      mention.firstName ||
      mention.fullName ||
      mention.displayName ||
      String(mention.email || "").split("@")[0] ||
      ""
    );
  }
  return String(mention || "").split("@")[0] || String(mention || "");
}

export function getActiveMentionQuery(text, cursorPos) {
  const before = String(text || "").slice(0, cursorPos);
  const at = before.lastIndexOf("@");
  if (at === -1) return null;
  if (at > 0 && !/\s/.test(before[at - 1])) return null;
  const query = before.slice(at + 1);
  // Whitespace ends the mention token — keep typing normal comment text afterward.
  if (/[\n\r@\s]/.test(query)) return null;
  return { start: at, query };
}
